import React from "react"
import Box from "@mui/material/Box"
import CircularProgress from "@mui/material/CircularProgress"
import Radio from "@mui/material/Radio"
import Typography from "@mui/material/Typography"

import { ButtonLarge } from "../../../Button"
import { FormPageProps } from "../.."

import useRaiseTicketChargerDetails from "./useRaiseTicketChargerDetails"
import MuiTable from "../../../MuiTable"

const ChargerDetails = ({ handleNextStep, handleCloseForm, module }: FormPageProps) => {
    const { columns, formik, addChargerRow, isChargersBySiteIdLoading } = useRaiseTicketChargerDetails({
        module: module!,
        handleNextStep,
    })

    return (
        <>
            <div className="charger_details section mb-24">
                <Box>
                    <Typography variant="label" textTransform={"none"}>
                        Is the entire station being dismantled?*
                    </Typography>
                    <Box display={"flex"} gap={"16px"}>
                        <Box display={"flex"} alignItems={"center"}>
                            <Radio
                                checked={formik.values.is_entire_station_being_dismantled}
                                onChange={e =>
                                    formik.setFieldValue("is_entire_station_being_dismantled", e.target.checked)
                                }
                                value={true}
                                id="is_entire_station_being_dismantled-yes"
                                name="is_entire_station_being_dismantled-radio"
                                size="small"
                                sx={{
                                    "& .MuiSvgIcon-root": {
                                        fontSize: 16,
                                    },
                                }}
                            />{" "}
                            <label htmlFor="is_entire_station_being_dismantled-yes" className="text-13 ">
                                Yes
                            </label>
                        </Box>
                        <Box display={"flex"} alignItems={"center"}>
                            <Radio
                                checked={!formik.values.is_entire_station_being_dismantled}
                                onChange={e =>
                                    formik.setFieldValue("is_entire_station_being_dismantled", e.target.checked)
                                }
                                value={false}
                                id="is_entire_station_being_dismantled-no"
                                name="is_entire_station_being_dismantled-radio"
                                size="small"
                                sx={{
                                    "& .MuiSvgIcon-root": {
                                        fontSize: 16,
                                    },
                                }}
                            />{" "}
                            <label htmlFor="is_entire_station_being_dismantled-no" className="text-13 ">
                                No
                            </label>
                        </Box>
                    </Box>
                </Box>
                <div className="mt-24">
                    {isChargersBySiteIdLoading ? (
                        <Box display="flex" alignItems="center" justifyContent="center" gap={1} fontSize={12}>
                            <CircularProgress size={16} /> Fetching chargers...
                        </Box>
                    ) : (
                        <>
                            <MuiTable columns={columns} rows={formik.values.chargers} />
                            {/* {!hideAddChargerButton && isChargerDetailsEditable && ( */}
                            <div className="d-flex justify-content-center py-24">
                                <ButtonLarge className="add_charger_button" onClick={addChargerRow}>
                                    + Add New Charger
                                </ButtonLarge>
                            </div>
                        </>
                    )}
                </div>
            </div>
            <footer className="raise-ticket-form__footer">
                <button className="raise-ticket-form__footer-button cancel-btn" onClick={handleCloseForm}>
                    Cancel
                </button>
                <button className="raise-ticket-form__footer-button next-btn" onClick={() => formik.handleSubmit()} disabled={isChargersBySiteIdLoading}>
                    Next
                </button>
            </footer>
            {/* )} */}
        </>
    )
}

export default ChargerDetails
